import { render, staticRenderFns } from "./registration-header.vue?vue&type=template&id=0ad44360&"
import script from "./registration-header.vue?vue&type=script&lang=ts&"
export * from "./registration-header.vue?vue&type=script&lang=ts&"
import style0 from "./registration-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports